import { Box } from '@mui/material';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useEffect, useState } from 'react';
import GatewayDetailDrawer from './GatewayDetailDrawer';

const GatewayDataGrid = (props) => {
  const { gateways, isLoading } = props;
  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const initialRowsData = gateways?.map((gateway) => ({
      id: gateway?.GatewayId,
      GatewayId: gateway?.GatewayId,
      Name: gateway?.Name,
      Online: gateway?.Online,
      ConnectedSensors: gateway?.SensorActivities.length,
      ConnectionStatus: gateway?.ConnectionStatus,
    }));
    setRows(initialRowsData);
  }, [gateways]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows?.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleRowClick = (params) => {
    if (selectedRow && selectedRow.id === params.row.id) {
      setSelectedRow(null);
      setDrawerOpen(!drawerOpen);
    } else {
      setSelectedRow(params.row);
      setDrawerOpen(true);
    }
  };

  const getRowClassName = (params) => {
    return selectedRow && selectedRow.id === params.id ? 'selected-row' : '';
  };

  const columns = [
    {
      field: 'Online',
      headerName: '',
      width: 75,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: params.value ? 'success.main' : 'error.main',
              }}
            />
          </Box>
        );
      },
    },
    { field: 'GatewayId', headerName: 'Gateway ID' },
    { field: 'Name', headerName: 'Name', width: 200 },
    {
      field: 'ConnectionStatus',
      headerName: 'Connection Type',
      flex: 1,
      renderCell: (params) => {
        const connectionKeywords = ['Dongle', 'Wifi', 'Mobile', 'Ethernet'];

        const foundConnections = connectionKeywords.filter((keyword) =>
          Object.keys(params.value).some(
            (key) => key.includes(keyword) && params.value[key] !== null,
          ),
        );

        const connectionType =
          foundConnections.length > 0 ? foundConnections.join(' + ') : 'None';

        return <>{connectionType}</>;
      },
    },
  ];

  return (
    <>
      <DataGridPremium
        rows={rows}
        columns={columns}
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={processRowUpdate}
        onRowClick={handleRowClick}
        getRowClassName={getRowClassName}
        isLoading={isLoading}
      />
      <GatewayDetailDrawer
        gateway={selectedRow}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  );
};

export default GatewayDataGrid;
